<template>
    <paper class="waybill-manage-mip" v-loading="loading">
        <div class="btn">
            <el-button
                type="primary"
                v-if="mipUrl"
                :loading="loading"
                @click="submitMip"
            >MIP提交</el-button>
        </div>
        <div class="button-wrapper">
            <el-upload
                class="upload-demo"
                ref="upload"
                action="upload"
                :on-error="handleError"
                :on-exceed="handleExceed"
                :before-upload="beforeUpload"
                :http-request="submitUpload"
                :auto-upload="importConfig.manualUpload"
                :multiple="importConfig.multiple"
                :show-file-list="importConfig.showFileList"
                :disabled="fileList.length >= 3 || !isEdit"
                :accept="importConfig.accept"
                :with-credentials="true"
                :file-list="fileList"
            >
                <el-button
                    size="small"
                    type="primary"
                    icon="el-icon-upload"
                    :disabled="fileList.length >= 3 || !isEdit"
                    :loading="uploadBtnLoading"
                >
                    上传凭证</el-button
                >
            </el-upload>
        </div>
        <div class="file-list" v-for="(item, index) in fileList" :key="index">
            <span>{{ item.name }}</span>
            <el-button
                type="text"
                icon="el-icon-download"
                @click="handleDownLoad(item.path)"
            ></el-button>
            <el-button
                type="text"
                icon="el-icon-delete"
                :disabled="!isEdit"
                @click="handleDelete(index)"
            ></el-button>
        </div>
        <div class="table-wrapper">
            <span class="table-title">白名单申请明细</span>
            <performance-table-box
                :config="tableConfig"
                v-loading="tableLoading"
                :tableData="tableData"
                :currentPage="searchParams.pageNo"
                :pageSize="searchParams.pageSize"
                :total="pageTotal"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
            ></performance-table-box>
        </div>

        <el-divider></el-divider>

        <iframe ref="frameRef" class="ifr" :src="mipUrl" v-if="mipUrl && !loading"/>
    </paper>
</template>

<script>
import paper from '@/components/core/paper/Paper';
import { queryDriverCostConfig, fileSave, getFileList, fileDelete, getIflowOrder, createProcess, getProcessStatus } from '@otp/api/waybillManageWhiteList.js';
import PerformanceTableBox from '../../../performanceManage/components/PerformanceTableBox';
import { tableConfig, importConfig } from './mipIframeConfig.js';
import { ossUpload } from '@/components/lots/OSS/api.js';
import { mapState } from 'vuex';
import { iflowPageURL } from '@otp/utils/iflowConf';
export default {
    name: 'waybillManageWhitelistDetail',
    components: { paper, PerformanceTableBox },
    data () {
        return {
            tableConfig,
            importConfig,
            pageTotal: 0,
            searchParams: {
                pageNo: 1,
                pageSize: 10
            },
            uploadBtnLoading: false,
            publicRead: 1,
            bucket: 'c-tms',
            businessKey: 'default',
            contentType: 'application/octet-stream',
            fileList: [],
            objId: '',
            requestId: '',
            tableData: [],
            loading: false,
            tableLoading: false,
            mipUrl: '',
            iflowStatus: '',
            createUserCode: '',
            currentPath: '/transport-center/waybill-manage-whitelist-detail'
        };
    },
    computed: {
        // 审批状态为草稿、驳回 && 登录用户为流程创建者 才可以编辑
        isEdit () {
            return this.user.userCode === this.createUserCode && ['10', '11'].includes(this.iflowStatus);
        },
        ...mapState({
            user: state => state.user,
            currentTenant: state => state.currentTenant
        })
    },
    async mounted () {
        if (this.$route.query.requestId) {
            this.requestId = this.$route.query.requestId;
            await this.init();
            window.addEventListener('message', this.messageFunc, false);
        }
    },
    async activated () {
        if (this.$route.query.requestId) {
            this.requestId = this.$route.query.requestId;
            await this.init();
            window.addEventListener('message', this.messageFunc, false);
        }
    },
    destroyed () {
        window.removeEventListener('message', this.messageFunc, false);
    },
    methods: {
        init () {
            this.loading = true;
            Promise.all([this.getObjId(), this.queryDriverCostConfig()])
                .catch(() => { })
                .finally(() => {
                    this.loading = false;
                });
        },
        queryDriverCostConfig () {
            const params = {
                ...this.searchParams,
                param: {
                    requestId: this.requestId
                }
            };
            this.tableLoading = true;
            queryDriverCostConfig(params)
                .then(res => {
                    if (res && +res.code === 0) {
                        this.tableData = res.data.list || [];
                        this.pageTotal = res.data.totalCount || 0;
                    }
                })
                .catch(() => { })
                .finally(() => { this.tableLoading = false; });
        },
        getObjId () {
            getIflowOrder(this.requestId).then(res => {
                if (res && +res.code === 0) {
                    this.objId = res.data.id;
                    this.iflowId = res.data.iflowId;
                    this.createUserCode = res.data.createUserCode;
                    this.mipUrl = this.iflowId ? iflowPageURL(this.user, this.iflowId) : '';
                }
            }).finally(() => {
                this.getFileList();
                this.getProcessStatus();
            });
        },
        getProcessStatus () {
            const param = {
                loginName: this.user.userCode,
                fdId: this.iflowId
            };
            getProcessStatus(param).then(res => {
                if (res && +res.code === 0) {
                    this.iflowStatus = res.data.fdStatusCode;
                }
            }).finally(() => { });
        },
        getFileList () {
            const params = {
                pageNo: 1,
                pageSize: 10,
                param: {
                    objId: this.objId,
                    objType: 'IFLOW_ORDER'
                }
            };
            getFileList(params)
                .then(res => {
                    if (res && +res.code === 0) {
                        this.fileList = res.data.list || [];
                    }
                })
                .catch(() => { })
                .finally(() => { });
        },
        beforeUpload (file) {
            if (this.verifyConfig && this.verifyConfig.switch) {
                if (this.verifyConfig.whiteList) {
                    const fileNameSuffix = file.name.substring(file.name.lastIndexOf('.') + 1);
                    if (this.verifyConfig.whiteList.indexOf(fileNameSuffix) === -1) {
                        const msg = this.verifyConfig.whiteList + '';
                        this.$message.warning(`上传文件只能是${msg}格式`);
                        return false;
                    }
                }
                if (this.verifyConfig.fileSize) {
                    const fileSizeVerify = file.size / 1024 < this.verifyConfig.fileSize;
                    if (!fileSizeVerify) {
                        this.$message.warning(`上传文件大小不能超过${this.verifyConfig.fileSize}KB`);
                        return false;
                    }
                }
            };
            const isText = file.type === 'application/vnd.ms-excel';
            const isTextComputer = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
            return (isText | isTextComputer);
        },
        submitUpload (uploadData) {
            const file = new File([uploadData.file], uploadData.file.name, {
                type: uploadData.file.type
            });
            this.uploadBtnLoading = true;
            const formData = new FormData();
            formData.append('file', file);
            formData.append('bucket', this.bucket);
            formData.append('businessKey', this.businessKey);
            formData.append('publicRead', this.publicRead);
            formData.append('contentType', this.contentType);
            ossUpload(formData)
                .then((res) => {
                    if (res && +res.code === 0) {
                        const param = this.callbackFileInfo(res.data.downUrl, uploadData.file);
                        fileSave(param)
                            .then(res => {
                                if (res && +res.code === 0) {
                                    this.$message.success('上传成功');
                                }
                            })
                            .catch(() => { })
                            .finally(() => {
                                this.getFileList();
                            });
                    }
                })
                .catch(() => { })
                .finally(() => {
                    this.uploadBtnLoading = false;
                });
        },
        /**
         * @description 处理上传成功回调参数
         * @param {String} url oss响应的url
         * @param {Object} file 文件对象
         */
        callbackFileInfo (url, file) {
            const name = file.name;
            const fileSize = (file.size / 1024).toFixed(0);
            return {
                name,
                fileSize,
                path: url,
                objId: this.objId,
                objType: 'IFLOW_ORDER'
            };
        },
        // 上传失败
        handleError () {
            this.$message.warning('上传失败');
        },
        handleExceed () {
            this.$message.warning(`超出文件上传个数限制`);
        },
        handleDownLoad (downUrl) {
            if (!downUrl) {
                return this.$message.warning('获取附件下载地址失败，刷新页面重试');
            }
            window.location = downUrl;
        },
        handleDelete (index) {
            fileDelete(this.fileList[index].id).then(res => {
                if (res && +res.code === 0) {
                    this.$message.success('删除成功');
                }
            }).finally(() => { this.getFileList(); });
        },
        handleSizeChange (pageSize) {
            this.searchParams.pageNo = 1;
            this.searchParams.pageSize = pageSize;
            this.queryDriverCostConfig();
        },
        handleCurrentChange (pageNo) {
            this.searchParams.pageNo = pageNo;
            this.queryDriverCostConfig();
        },
        submitMip () {
            this.$refs.frameRef.contentWindow.postMessage('mbpm_getApprovalData', this.mipUrl);
        },
        getSubmitParams () {
            return {
                requestId: this.requestId,
                file: {
                    ...this.fileList
                }
            };
        },
        messageFunc (event) {
            // 只有在当前页面触发，才执行相应的监听事件
            if (this.$route.path !== this.currentPath) return;
            if (event.data && event.data.data && event.data.success) {
                const params = event.data.data;
                this.loading = true;
                createProcess(params)
                    .then(res => {
                        if (res && +res.code === 0) {
                            this.$message.success('提交成功');
                        } else {
                            this.$message.error(res.msg);
                        }
                    })
                    .finally(() => {
                        setTimeout(() => {
                            this.init();
                        }, 3000);
                    });
            }
        }
    }
};
</script>

<style lang="less">
.waybill-manage-mip {
    .button-wrapper {
        display: flex;
        margin-top: 10px;
        .el-icon-upload,
        .el-icon-download {
            font-size: 14px;
        }
        .upload-demo {
            margin: 0px 20px 0px 10px;
        }
    }
    .table-wrapper {
        display: grid;
        .table-title {
            font-size: 16px;
            display: inline-block;
            margin: 20px 0px 0px 10px;
        }
        .table-pagination {
            display: flex;
            justify-content: end;
        }
    }
    .file-list {
        text-align: center;
        color: #00bcbf;
        font-size: 14px;
        i.el-icon-download {
            font-size: 14px;
            margin-left: 10px;
        }
        i.el-icon-delete {
            font-size: 14px;
        }
    }
    .el-form-item {
        margin-bottom: 14px;
    }
    .btn {
        margin-left: 20px;
    }
    .ifr {
        width: 100%;
        height: 110vh;
        border: none;
    }
}
</style>
